"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var utils_1 = require("../../utils");
var Button_1 = require("../Button");
var Drop_1 = require("../Drop");
var hocs_1 = require("../hocs");
var styled_components_1 = require("styled-components");
var DropButton = /** @class */ (function (_super) {
    tslib_1.__extends(DropButton, _super);
    function DropButton(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonRef = React.createRef();
        _this.state = {};
        _this.onDropClose = function () {
            var onClose = _this.props.onClose;
            _this.setState({ show: false }, function () {
                if (onClose) {
                    onClose();
                }
            });
        };
        _this.onToggle = function () {
            var _a = _this.props, onClose = _a.onClose, onOpen = _a.onOpen;
            var show = _this.state.show;
            _this.setState({ show: !show }, function () { return (show ? onClose && onClose() : onOpen && onOpen()); });
        };
        _this.state = {
            show: props.open || false
        };
        return _this;
    }
    DropButton.getDerivedStateFromProps = function (nextProps, prevState) {
        var show = prevState.show;
        var open = nextProps.open;
        if (open !== undefined && open !== show) {
            return { show: open };
        }
        return null;
    };
    DropButton.prototype.componentDidMount = function () {
        var open = this.props.open;
        if (open) {
            this.forceUpdate();
        }
    };
    DropButton.prototype.componentDidUpdate = function (prevProps, prevState) {
        var forwardRef = this.props.forwardRef;
        var show = this.state.show;
        if (!show && prevState.show) {
            // focus on the button if the drop is closed
            utils_1.setFocusWithoutScroll((forwardRef || this.buttonRef).current);
        }
    };
    DropButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, dropAlign = _a.dropAlign, forwardRef = _a.forwardRef, dropContent = _a.dropContent, dropTarget = _a.dropTarget, id = _a.id, open = _a.open, theme = _a.theme, rest = tslib_1.__rest(_a, ["disabled", "dropAlign", "forwardRef", "dropContent", "dropTarget", "id", "open", "theme"]);
        var show = this.state.show;
        delete rest.onClose;
        delete rest.onOpen;
        var drop;
        if (show && (forwardRef || this.buttonRef).current) {
            drop = (React.createElement(Drop_1.Drop, { id: id ? id + "__drop" : undefined, restrictFocus: true, target: dropTarget || (forwardRef || this.buttonRef).current, onClickOutside: this.onDropClose, onEsc: function (event) {
                    // prevents layer to close on esc
                    event.stopPropagation();
                    if (event.nativeEvent) {
                        event.nativeEvent.stopImmediatePropagation();
                    }
                    _this.onDropClose();
                } }, dropContent));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Button_1.Button, tslib_1.__assign({ id: id, ref: forwardRef || this.buttonRef, disabled: disabled, onClick: this.onToggle }, rest)),
            drop));
    };
    DropButton.defaultProps = {
        a11yTitle: 'Open Drop',
        dropAlign: { top: 'top', left: 'left' }
    };
    return DropButton;
}(React.Component));
var DropButtonWrapper = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(DropButton);
exports.DropButton = DropButtonWrapper;
//# sourceMappingURL=DropButton.js.map